import { useContext } from 'react';
import { AlertMessageContext } from '../contexts';

export const useAlertMessage = () => useContext(AlertMessageContext);
